import axios from 'axios'
import router from '../../router'

const state = {
  adminRoles: []
}

const getters = {
  getAdminRole (state) {
    return state.adminRoles
  }
}

const mutations = {
  setAdminRole (state, payload) {
    state.adminRoles = payload
  }
}
const actions = {
  apiSysadminUsersAdminrole (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.method === 'POST') {
        axios.post('/api/sysadmin/users', payload)
          .then((response) => {
            alert('저장되었습니다.')
            context.dispatch('apiSysadminUsersAdminrole', {method: 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else if (payload.method === 'PATCH') {
        axios.patch('/api/sysadmin/users/' + payload.id, payload)
          .then((response) => {
            alert('저장되었습니다.')
            context.dispatch('apiSysadminUsersAdminrole', {method: 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else { // GET method
        axios.get('/api/sysadmin/users/adminrole')
          .then((response) => {
            context.commit('setAdminRole', response.data)
            context.dispatch('apiCommonsStatus')
            context.dispatch('apiSysadminGroupsCombo')
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/sessiontimeout')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adminmanager.js